import { Schemas } from "../types/api-types";
import apiClient from "../clients/apiClient";
import { ApiResponse } from "../schemas/apiResponseSchema";


export type LanguageResponse = Schemas['LanguageResponse'];

export interface LanguageListResponse {
    languages: LanguageResponse[];
    total: number;
}

/**
 * Get all available languages
 */
export async function getAllLanguages(): Promise<LanguageListResponse> {
    try {
        const response: ApiResponse<LanguageListResponse> = (
            await apiClient.get('/language')
        ).data;
        return response.data;
    } catch (error: any) {
        if (error.response?.data?.detail) {
            throw new Error(error.response.data.detail);
        }
        throw new Error('Failed to fetch languages');
    }
}

/**
 * Get a specific language by ID
 */
export async function getLanguageById(languageId: number): Promise<LanguageResponse> {
    try {
        const response: ApiResponse<LanguageResponse> = (
            await apiClient.get(`/language/${languageId}`)
        ).data;
        return response.data;
    } catch (error: any) {
        if (error.response?.data?.detail) {
            throw new Error(error.response.data.detail);
        }
        throw new Error(`Failed to fetch language with ID ${languageId}`);
    }
}

/**
 * Get a specific language by language code
 */
export async function getLanguageByCode(languageCode: string): Promise<LanguageResponse> {
    try {
        const response: ApiResponse<LanguageResponse> = (
            await apiClient.get(`/language/code/${encodeURIComponent(languageCode)}`)
        ).data;
        return response.data;
    } catch (error: any) {
        if (error.response?.data?.detail) {
            throw new Error(error.response.data.detail);
        }
        throw new Error(`Failed to fetch language with code ${languageCode}`);
    }
}

/**
 * Get a specific language by display name
 */
export async function getLanguageByName(displayName: string): Promise<LanguageResponse> {
    try {
        const response: ApiResponse<LanguageResponse> = (
            await apiClient.get(`/language/name/${encodeURIComponent(displayName)}`)
        ).data;
        return response.data;
    } catch (error: any) {
        if (error.response?.data?.detail) {
            throw new Error(error.response.data.detail);
        }
        throw new Error(`Failed to fetch language with name ${displayName}`);
    }
}
